export function useImgUrl(imgUrl: any) {
	if (imgUrl.includes("https://")) {
		return imgUrl;
	} else {
		return `${import.meta.env.VITE_IMG_URL}${imgUrl}`;
	}
}
export function useThemeImgUrl(imgUrl: any) {
	const themeCode = "default";
	return `/image/${themeCode}/${imgUrl}`;
}
